var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.items,"outlined":"","label":"Region","value":_vm.value,"clearable":""},on:{"change":_vm.emitValue}})}
var staticRenderFns = []

export { render, staticRenderFns }